import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { Typography } from '@/shared/ui';

import { ROUTES } from '@/router/baseRoutes';

import { Notification as NotificationType, NotificationType as NotificationTypeType } from '@/api/types';

import { Notification } from './Notification';

import './NotificationsStyles.scss';

interface Props {
  date: string;
  notifications: NotificationType[];
  toggleNotificationsModal: VoidFunction;
}

export const NotificationsDateGroup = React.memo<Props>(({ date, notifications, toggleNotificationsModal }) => {
  const navigate = useNavigate();
  const onNotificationClick = useCallback(
    (notificationType: NotificationTypeType) => (): void => {
      if (notificationType === 'info') {
        toggleNotificationsModal();
        navigate(ROUTES.USER.REQUESTS.ACTIVE_REQUESTS);
      }
    },
    [toggleNotificationsModal],
  );

  return (
    <div className="notifications__date-group">
      <Typography className="notifications__date-group-title" variant="TEXT16">
        {date}
      </Typography>
      {notifications.map(({ type, header, created_at, body, status_decorator }) => (
        <Notification
          key={created_at}
          type={type}
          title={header}
          date={created_at}
          message={body}
          status_decorator={status_decorator}
          onNotificationClick={onNotificationClick(type)}
        />
      ))}
    </div>
  );
});
